import {useState} from 'react';
import {Platform,useWindowDimensions,type LayoutChangeEvent,type ViewStyle} from 'react-native';
import {pageFrameWidth} from '../shared/page-frame.js';

export function usePageFrame(){
 const {width}=useWindowDimensions(),[measured,setMeasured]=useState<{viewport:number;available:number}|null>(null);
 const padding=width>=1000?24:16;
 const available=measured?.viewport===width?measured.available:width;
 const target=pageFrameWidth(width,available,padding);
 return {
  onLayout:(e:LayoutChangeEvent)=>{const next=e.nativeEvent.layout.width;setMeasured(old=>old?.viewport===width&&Math.abs(old.available-next)<.1?old:{viewport:width,available:next});},
  scrollStyle:Platform.OS==='web'?{scrollbarGutter:'stable',overflowY:'scroll'} as ViewStyle:undefined,
  // Undefined does not override an earlier maxWidth in a React Native style array.
  contentStyle:{width:Platform.OS==='web'&&target<available?target:'100%',maxWidth:'100%',alignSelf:'center',paddingHorizontal:padding,paddingTop:16,paddingBottom:Platform.OS==='web'?(width<420?180:40):16} as ViewStyle,
 };
}
